
import { Component, Vue } from 'vue-property-decorator';
import { Franchise, Office } from 'client-website-ts-library/types';
import { API, Config } from 'client-website-ts-library/services';

@Component
export default class Footer extends Vue {
  private office: Office | null = null;

  mounted() {
    this.loadOffices();
  }

  loadOffices(): void {
    API.Offices.Get(Config.Website.Settings!.WebsiteId).then((office) => {
      this.office = office;
    });
  }

  // eslint-disable-next-line
  scrollToTop(): void {
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  // eslint-disable-next-line
  get year(): string {
    return new Date().getFullYear().toString();
  }

  get hideMap(): boolean {
    return this.$route.meta?.hideOfficeMap;
  }
}
